import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ROUTES } from 'src/app/constants';
import { InvitationComponent } from './invitation.component';


const routes: Routes = [
  { path: ROUTES.ROOT, component: InvitationComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class InvitationRoutingModule { }
